import React from "react";
import { HeroSection, Title, Subtitle } from "../About.styles";

const Hero = () => {
  return (
    <HeroSection>
        <Title>
            Transforming How The World Experiences Trekking
        </Title>

        <Subtitle>
            We're building a global community of adventurers who believe in the 
            power of shared experiences, sustainable travel, and the transformative 
            nature of connecting with nature and each other.
        </Subtitle>
    </HeroSection>
  );
};

export default Hero;